var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-pane-template',{attrs:{"title":"エンタープライズ"}},[_c('enterprise-selection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }